module.exports = __webpack_public_path__ + "img/clothing196.d355f3df.jpg";